import React, { useEffect } from "react";
import Cookies from "js-cookie";
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useNavigate } from "react-router-dom";
import { getGroupsStatus } from './dashboardSlice';
import StarIcon from "../game/finish/svgs/startIcon";

function ScoreboardDashboard()
{
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const cookieGameId = Cookies.get('game_id');

  const groups = useSelector((state) => state.dashboard.groupStatus);

  useEffect(()=> {
    document.querySelector('meta[name="theme-color"]').setAttribute('content',  '#292929');

    dispatch(getGroupsStatus(cookieGameId));

    // let interval = setInterval(() => {
    //     dispatch(getGroupsStatus(cookieGameId));
    // }, 3000);

    // return () => clearInterval(interval);
    
  }, []);

  useEffect(() => {
    if (groups && groups.length > 0) {
        
    }
  }, [groups]);

  const getAnimationClass = (group) => {
    let animClass = '';
    if (group.missions_started) {
        if (group.rank === 1 && group.oldRank !== 1) {
            animClass = 'first-place-animation';
        } else if (group.rank === 2 && group.oldRank !== 2) {
            animClass = 'second-place-animation';
        } else if (group.rank === 3 && group.oldRank !== 3) {
            animClass = 'third-place-animation';
        } else if(group.rank > group.oldRank) {
            animClass = 'thumbs-up-animation';
        } 
        
        if(group.score > group.oldScore){
            const newStars = group.score - group.oldScore;
            animClass = ' star-animation';
            if(newStars === 1){
                animClass += ' star-animation-1';
            } else if(newStars === 2){
                animClass += ' star-animation-2';
            } else if(newStars === 3){
                animClass += ' star-animation-3';
            }
        }


    }
    return animClass;
  }

  return (
    <div className="dashboard-container scoreboard-digiboard">
      <div className="groups-wrapper">
      {groups &&
                    [...groups].sort((a,b) => a.group_id > b.group_id ? 1 : -1).map((group, key) => (
                        <div className={`group-wrapper ${group.missions_started ? '' : 'waiting'} ${ group.missions_started && group.rank === 1 ? 'first-place' : ''} ${group.missions_started && group.rank === 2 ? 'second-place' : ''} ${ getAnimationClass(group)}`} key={group.group_id}>
                        <div className="group-card">
                            <div className="group-avatar-wrapper">
                                <div className="avatar-floor"></div>
                                <div className="avatar-image" 
                                  style={{
                                    backgroundImage: `url('/storage/avatar/group_${group.group_id}.png?${new Date().getTime()}')`,
                                  }}
                                ></div>
                                <div className="loading-banner">
                                    <span>Groep samenstellen...</span>
                                </div>
                            </div>
                            <div className="group-name">
                                    <>
                                        <div className="group-old-position">{group.oldRank}</div>
                                        <div className="group-position">{group.rank}</div>
                                    </>
                                
                                <div className="name">
                                    <span>{group.name}</span>
                                </div>
                            </div>
                            {group.missions_started && group.rank === 1 &&
                                <div className="cup">
                                    <img src="/images/cup.png" alt="cup" width={50} />
                                </div>
                            }
                            
                            <div className="emojis">
                                <div className="animation one-star">
                                    <img src="/images/emoji-star.png" alt="1 star" width={40} />
                                </div>
                                <div className="animation two-stars"></div>
                                <div className="animation three-stars"></div>
                                <div className="animation first-place"></div>
                                <div className="animation thumbsup"></div>
                            </div>
                        </div>
                    </div>
                    ))}







      </div>
      <div className="score-board-wrapper">
        <div className="title-wrapper">
          <h3>{t("student.groups_overview.rankings")}</h3>


          {/*
          <ul className="group-list">
            {groups &&
              groups.map((group, key) => (
                <li key={group.group_id} className={`${group.missions_started ? '' : 'waiting'}`}>
                  <div className="group-position">
                    {group.missions_started ? key + 1 : ''}
                  </div>
                  <div className="group-details">
                    <div className="group-name">
                      {group.name}
                    </div>
                    <span className="group-members">
                      {group.missions_started && group.players &&
                        group.players
                          .map((player) => player.name)
                          .join(", ")}
                    </span>
                  </div>
                  <div className="group-score">
                    {group.missions_started &&
                      <div className="group-score-wrapper">
                        <StarIcon />
                        <span>x{group.score}</span>
                      </div>
                    }
                    {!group.missions_started &&
                      <span className="waiting-score">...</span>
                    }
                  </div>
                </li>
              ))}
          </ul>*/}


          


        </div>
        <ul className="group-list frameGoldOpen multi">
            {groups &&
              groups.map((group, key) => (
                <li key={group.group_id} className={`group-item ${key === 0 ? 'first' : ''} ${key === 1 ? 'second' : ''} ${key === 2 ? 'third' : ''} ${key > 2 ? 'neutral' : ''} ${group.missions_started ? '' : 'waiting'}`}>
                  <div className="group-position"><span className="number">{key + 1}</span></div>
                  <div className="group-title">
                    <div className="group-name">{group.name}</div>
                    <div className="group-score">{group.players && group.players.map((player) => player.name).join(", ")}</div>
                  </div>
                  <div className="group-score-container">
                    <div className="collectable"></div>
                    <span className="multiplier">x</span>
                    <span className="score">{group.score}</span>
                  </div>
                </li>
              ))}
          </ul>
      </div>
    </div>
  );
}

export default ScoreboardDashboard;

/*

<div className="content-wrapper">
              <div className="game-board">
                  <div className="groups-wrapper">
                  {groups &&
                    [...groups].sort((a,b) => a.group_id > b.group_id ? 1 : -1).map((group, key) => (
                        <div className={`group-wrapper ${group.missions_started ? '' : 'waiting'} ${ group.missions_started && group.rank === 1 ? 'first-place' : ''} ${group.missions_started && group.rank === 2 ? 'second-place' : ''} ${ getAnimationClass(group)}`} key={group.group_id}>
                        <div className="group-card">
                            <div className="group-avatar-wrapper" style={{ backgroundImage: `url('/storage/avatar/group_${group.group_id}.png')` }}>

                                <div className="loading-banner">
                                    <span>Groep samenstellen...</span>
                                </div>
                            </div>
                            <div className="group-name">
                                {group.missions_started && 
                                    <>
                                        <div className="group-old-position">{group.oldRank}</div>
                                        <div className="group-position">{group.rank}</div>
                                    </>
                                }
                                
                                <div className="name">
                                    <span>{group.name}</span>
                                </div>
                            </div>
                            {group.missions_started && group.rank === 1 &&
                                <div className="cup">
                                    <img src="/images/cup.png" alt="cup" width={50} />
                                </div>
                            }
                            
                            <div className="emojis">
                                <div className="animation one-star">
                                    <img src="/images/emoji-star.png" alt="1 star" width={40} />
                                </div>
                                <div className="animation two-stars"></div>
                                <div className="animation three-stars"></div>
                                <div className="animation first-place"></div>
                                <div className="animation thumbsup"></div>
                            </div>
                        </div>
                    </div>
                    ))}
                    {/* <div className="group-wrapper position-change">
                        <div className="group-card">
                            <div className="group-avatar-wrapper">
                            </div>
                            <div className="group-name">
                                <div className="group-position">2</div>
                                <div className="group-position-change">+1</div>
                                <div className="name">
                                    <span>Group 2</span>
                                </div>
                            </div>
                            <div className="cup">

                            </div>
                            <div className="emojis">
                                
                            </div>
                        </div>
                    </div> }
                
                    </div>
                    </div>
                    <div className="score-board-wrapper">
                        <h3>{ t("digiboard.open.title_2") }</h3>
                        <ul className="group-list">
                            {groups &&
                                groups.map((group, key) => (
                                    <li key={group.group_id} className={`${group.missions_started ? '': 'waiting'}`}>
                                        <div className="group-position">
                                            {group.missions_started ? key + 1 : ''}
                                        </div>
                                        <div className="group-details">
                                            <div className="group-name">
                                                {group.name}
                                            </div>
                                            <span className="group-members">
                                                {group.missions_started && group.players &&
                                                    group.players
                                                        .map((player) => player.name)
                                                        .join(", ")}
                                            </span>
                                        </div>
                                        <div className="group-score">
                                          {group.missions_started &&
                                          <div className="group-score-wrapper">
                                              <StarIcon />
                                              <span>x{group.score}</span>
                                          </div>
                                          }
                                          { !group.missions_started && 
                                              <span className="waiting-score">...</span>
                                          }
                                        </div>
                                    </li>
                                ))}
                        </ul>
                    </div>
                </div>*/